// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Permission row layout */
.perm-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 6px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  gap: 8px;
}

.perm-row:last-child {
  border-bottom: none;
}

.perm-row-report {
  padding-left: 10px;
}

.perm-label {
  font-size: 0.85rem;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Section header inside card */
.perm-section-header {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6c757d;
  padding: 8px 6px 2px;
  margin-top: 4px;
}

/* 3-state segmented radio group */
.perm-access-group {
  display: flex;
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.perm-access-group.disabled {
  opacity: 0.45;
  pointer-events: none;
}

.perm-access-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  font-size: 0.75rem;
  cursor: pointer;
  background: rgba(var(--ct-primary-rgb, 44, 142, 248), 0.06);
  color: var(--bs-body-color, #495057);
  border-right: 1px solid var(--bs-border-color, #dee2e6);
  margin: 0;
  transition: background 0.15s, color 0.15s;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.perm-access-btn:last-child {
  border-right: none;
}

.perm-access-btn input[type="radio"] {
  display: none;
}

.perm-access-btn.active {
  background: var(--bs-primary, #2c8ef8);
  color: #fff;
  font-weight: 600;
}

.perm-access-btn:not(.active):hover {
  background: var(--bs-secondary-bg, #f0f4ff);
}

/* Dark mode: row divider uses theme-aware border color */
.perm-row {
  border-bottom-color: var(--bs-border-color, rgba(0, 0, 0, 0.05));
}

/* Permission cards grid — auto-fill columns, cards stretch to fill row height */
.perm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
  align-items: start;
}

.perm-grid > div {
  display: flex;
  flex-direction: column;
}

.perm-grid .card {
  height: 100%;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
